import axios from "@/plugins/axios";

export default {
    actions: {
        pushEpos(context, data) {
            let url = (' ' + data.url).slice(1);
            delete data.url

            return axios.post(url, data)
                .then((response) => {
                    context.commit('updateEpos', response.data)
                    console.log(response)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        setIntegrationState(context, isNeedIntegration) {
            context.commit('updateIntegrationState', isNeedIntegration)
        }
    },
    mutations: {
        updateEpos(state, data) {
            state.epos = data
            localStorage.setItem('paycheck', data.paycheck)
        },
        updateIntegrationState(state, isNeedIntegration) {
            localStorage.setItem('isNeedIntegration', isNeedIntegration)
        }
    },
    state: {
        epos: {
            error: false,
            info: {
                terminalId: null,
                receiptSeq: null,
                fiscalSign: null,
                qrCodeURL: null,
                dateTime: null,
            },
            paycheck: localStorage.getItem('paycheck')
        },
        isNeedIntegration: localStorage.getItem('isNeedIntegration')
    },
    getters: {
        getEpos(state) {
            return state.epos
        },
        getIntegrationState(state) {
            return state.isNeedIntegration
        }
    },
}
